<template>
    <el-dialog
      v-if="openDialog"
      :title="!!data.id ? '编辑视频' : '添加视频'"
      :visible.sync="openDialog"
      :width="isLook ? '70%' : '50%'"
      :class="isLook ? 'flexbox' : ''"
      :before-close="close"
    >
      <!-- 视频播放 -->
      <div class="video">
        <xg-player ref="player" :url="videoUrl" @triggerEvent="triggerEvent"></xg-player>
      </div>
      <div :class="isLook ? 'formboxs' : 'normalbox'">
        <el-form
          :rules="rules"
          ref="form"
          :model="form"
          label-width="120px"
          :hide-required-asterisk="true"
          v-loading="dialogLoading"
        >
          <el-form-item label="竖版封面" prop="vertical_cover">
            <uploadImage
              :imageUrl="form.vertical_cover"
              @uploadFileUrl="uploadImg"
              @clearImage="clearImage"
              @validate="validateImage"
              :objKey="'vertical_cover'"
            ></uploadImage>
          </el-form-item>
          <el-form-item label="横版封面" prop="horizontal_cover">
            <uploadImage
              :imageUrl="form.horizontal_cover"
              @uploadFileUrl="uploadImg"
              @clearImage="clearImage"
              @validate="validateImage"
              :objKey="'horizontal_cover'"
            ></uploadImage>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" v-loading="loading">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </template>
  
  <script>
    import uploadImage from '@/views/medium/components/uploadImage';
    import config from '../../../utils/serverUrlConfig';
    import local from '@/utils/localStroage.js';
    import XgPlayer from './XgPlayer.vue';
  
    export default {
      name: 'videoDialog',
      props: ['data', 'parentsList', 'isLook'],
      components: { uploadImage, XgPlayer },
      data() {
        return {
          videoUrl: '',
          openDialog: false,
          form: {},
          loading: false,
          rules: {
            vertical_cover: [{ required: true, message: '请选择竖版封面', trigger: 'blur' }],
            horizontal_cover: [{ required: true, message: '请选择横版封面', trigger: 'blur' }],
          },
          dialogLoading: false,
        };
      },
      watch: {
        data(data) {
          this.form = data;
        },
      },
      methods: {
        triggerEvent(value) {
          console.log('是否播放：', value);
        },
        validate(callback) {
          this.$refs.form.validate((valid) => {
            callback(valid);
          });
        },
        close() {
          if (this.$refs.player && this.$refs.player.teardown) {
            this.$refs.player.teardown();
          } else if (this.$refs.player && this.$refs.player.destroyPlayer) {
            this.$refs.player.destroyPlayer();
          }
          this.$emit('clearData');
        },
        uploadImg(key, value, multiple) {
          if (multiple) {
            let str = this.form[key] + ',' + value;
            this.$set(this.form, key, str);
          } else {
            this.$set(this.form, key, value);
          }
        },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.$emit('pushData', this.form);
              this.loading = true;
            } else {
              return false;
            }
          });
        },
        clearImage(key, data, multiple) {
          if (multiple) {
            this.form[key] = data;
          } else {
            this.form[key] = '';
          }
        },
        validateImage(value, imagesUrl) {
          this.$set(this.form, value, imagesUrl);
        },
        loadVideo(data) {
          this.$nextTick(() => {
            this.videoUrl = `${config.baseServerUrl}/api/m3u8/${data}?token=${local.get('userInfo').token}`;
          });
        },
      },
    };
  </script>
  
  <style scoped lang="scss">
    .el-dialog ::v-deep .el-select {
      width: 100% !important;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .video {
      width: 550px;
    }
    .flexbox ::v-deep .el-dialog__body {
      display: flex;
      justify-content: space-between;
    }
    .formboxs {
      width: calc(100% - 500px);
      max-height: 630px;
      overflow-y: auto;
    }
    .normalbox {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 20px;
    }
  </style>
  